module.exports = __webpack_public_path__ + "img/logo4.44a027ca.png";